import { parseNovelTtsEvent } from '@drama/contracts/novel'

/**
 * 互动小说对白配音（NDJSON 流，事件见 contracts 的 NovelTtsEvent）。只传段落 id：文本、说话人与音色都由服务端定（C3）。
 * @param {{ request: Function, stream: Function }} transport
 */
export function createNovelTtsApi(transport, { prefix = '/api/novel/runs' } = {}) {
  return {
    /** @param {{ run_id: string, segment_id: string }} args */
    speak({ run_id, segment_id }) {
      return transport.stream('POST', `${prefix}/${encodeURIComponent(run_id)}/tts`, { body: { segment_id }, parse: parseNovelTtsEvent })
    },
  }
}
